import { useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { OtpVerify } from "../components/site/OtpVerify";
import { OTP_KEY, REF_KEY } from "../lib/api";

export default function VerifyEmail() {
  const [challenge, setChallenge] = useState(() => JSON.parse(sessionStorage.getItem(OTP_KEY) || "null"));
  const [done, setDone] = useState(null);

  const onVerified = (data) => {
    sessionStorage.removeItem(OTP_KEY);
    sessionStorage.removeItem(REF_KEY);
    setDone(data);
  };

  return (
    <div className="relative min-h-[80vh] py-20" data-testid="verify-email-page">
      <div className="absolute inset-0 grid-bg opacity-40" />
      <div className="relative max-w-md mx-auto px-5">
        <div className="card-surface lime-glow p-8">
          {done ? (
            <div className="text-center space-y-5" data-testid="verify-success">
              <CheckCircle2 size={52} className="mx-auto text-[#B7FF3C]" />
              <h1 className="text-3xl font-black uppercase leading-tight">{done.newly_verified ? "You're officially on the CricAnalyze waitlist!" : "Welcome back!"}</h1>
              <p className="text-[#A3ADA3]">{done.newly_verified ? "Your email is verified. Your private referral dashboard is ready." : "Your email is verified. Your existing account and referral data are ready."}</p>
              <Link to="/dashboard" data-testid="go-to-dashboard-btn" className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#B7FF3C] text-[#080A08] font-bold hover:bg-[#c9ff6a]">
                Open My Referral Dashboard <ArrowRight size={18} />
              </Link>
            </div>
          ) : challenge ? (
            <>
              <p className="eyebrow">Step 2 of 2</p>
              <h1 className="mt-2 mb-5 text-3xl font-black uppercase">Verify your email</h1>
              <OtpVerify challenge={challenge} onVerified={onVerified}
                onChallenge={(cid) => { const c = { ...challenge, challenge_id: cid }; setChallenge(c); sessionStorage.setItem(OTP_KEY, JSON.stringify(c)); }} />
            </>
          ) : (
            <div className="text-center space-y-4" data-testid="verify-no-session">
              <h1 className="text-2xl font-black uppercase">No verification in progress</h1>
              <p className="text-[#A3ADA3] text-sm">Join the waitlist or use View My Stats to receive a code.</p>
              <div className="flex gap-3 justify-center">
                <Link to="/join" className="px-5 py-2.5 rounded-full bg-[#B7FF3C] text-[#080A08] font-semibold">Join Waitlist</Link>
                <Link to="/dashboard" className="px-5 py-2.5 rounded-full border border-[#2A362A]">View My Stats</Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
